import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function GroupAddedToCalendar({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.groupAddedToCalendarEvent"
      values={{
        events: util.getCalendarEventNames(events),
        group: ownerGroup?.name || "Deleted",
      }}
    />
  );
}
